export class GenericSlidersModel {
    QueryValue: string;
    SliderId: string;
    SliderName: string;
    Description1: string;
    Description2: string;
    Description3: string;
    UrlForward: string;
    UrlImage: string;
    Order: number;
    CreatedBy: string;
    Company: string;
    RecIdAX: number;
    Action: string;
    Idioma: string;

    constructor() {
        this.QueryValue = '';
        this.SliderId = '';
        this.SliderName = '';
        this.Description1 = '';
        this.Description2 = '';
        this.Description3 = '';
        this.UrlForward = '';
        this.UrlImage = '';
        this.Order = 0;
        this.CreatedBy = '';
        this.Company = '';
        this.RecIdAX = 0;
        this.Action = '';
        this.Idioma = '';
    }
  }
